import { defineComponent as _defineComponent } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'
import { useGetJobReferencesQuery } from '@/api/jobs'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobReferencesCard',
  props: {
    jobId: null
  },
  setup(__props: any) {

const props = __props as {
  jobId: string
}



const {
  data: references,
  isLoading,
  isError,
} = useGetJobReferencesQuery(props.jobId)

function getReferenceTypeString(referenceType: string) {
  switch (referenceType) {
    case 'oplii':
      return 'Oplii'
    case 'emaint':
      return 'eMaint'
    case 'open_ticket':
      return 'OpenTicket'
    default:
      return ''
  }
}

return { __sfc: true,props, references, isLoading, isError, getReferenceTypeString, VsWrapper, VsHeading, VsText }
}

})